exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading-overlay[data-v-2cd606d8]{\n    cursor: wait;\n    background: rgba(0, 0, 0, 0.4);\n    position: fixed;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    z-index: 10000;\n}\n", ""]);

// exports
